import React from 'react'
import styled from 'styled-components'
import zeroX from '../../assets/exchanges/0x.svg'
import oneInch from '../../assets/exchanges/1inch.svg'
import balancer from '../../assets/exchanges/balancer.svg'
import bancor from '../../assets/exchanges/bancor.svg'
import binance from '../../assets/exchanges/binance.svg'
import curve from '../../assets/exchanges/curve.svg'
import defiSwap from '../../assets/exchanges/defiswap.svg'
import dodo from '../../assets/exchanges/dodo.svg'
import integral from '../../assets/exchanges/integral.svg'
import kyber from '../../assets/exchanges/kyber.svg'
import oasis from '../../assets/exchanges/oasis.svg'
import paraSwap from '../../assets/exchanges/paraswap.svg'
import sakeSwap from '../../assets/exchanges/sakeswap.svg'
import sushiSwap from '../../assets/exchanges/sushiswap.svg'
import uniswap from '../../assets/exchanges/uniswap.svg'

interface Props {
  className?: string
  exchange: string
}

export function ExchangeImage({ className, exchange }: Props) {
  return <Image className={className} src={imageForExchange(exchange)} />
}

const Image = styled.img`
  display: block;
  width: 36px;
  height: 36px;
`

function imageForExchange(exchange: string) {
  switch (exchange) {
    case '0x':
      return zeroX
    case '1inch':
      return oneInch
    case 'Balancer':
    case 'BalancerV2':
      return balancer
    case 'Bancor':
      return bancor
    case 'Binance':
      return binance
    case 'Curve':
      return curve
    case 'DefiSwap':
      return defiSwap
    case 'Dodo':
      return dodo
    case 'Integral':
      return integral
    case 'Kyber':
      return kyber
    case 'Oasis':
      return oasis
    case 'ParaSwap':
      return paraSwap
    case 'SakeSwap':
      return sakeSwap
    case 'SushiSwap':
      return sushiSwap
    case 'UniswapV1':
    case 'UniswapV2':
    case 'UniswapV3':
      return uniswap
  }
}
